import { Injectable, signal } from '@angular/core';
import { RecertTaskInbox } from '../../api.service';

/**
 * ADR-0089 / F07 fix (page-gate widening): the recert-inbox ROUTE stays ENTITLEMENT_ADMIN-gated
 * for everyone else, but a reviewer who holds >=1 assigned pending task must be able to open
 * their own queue even without admin authority. Whether that's true is answered by the inbox
 * endpoint itself (scoped to the ACTING subject), not by a static entitlement -- so
 * RecertInboxComponent (which always mounts, even while the gate visually hides it -- see
 * PersonaGateOutletComponent) reports what it loaded here, and PersonaGateOutletComponent reads
 * it to widen the gate for THIS route only. Every other route's gate is untouched.
 */
@Injectable({ providedIn: 'root' })
export class RecertInboxAccessService {
  private readonly _hasPendingTask = signal(false);
  readonly hasPendingTask = this._hasPendingTask.asReadonly();

  reportTasks(tasks: RecertTaskInbox[]): void {
    this._hasPendingTask.set(tasks.length > 0);
  }
}
